import { useEffect, useState } from 'react';
import { policies, type PolicyDto } from '../net/api';
import { Markdown } from './Markdown';

/** Public page at /policies/<slug>; works without signing in. */
export function PolicyView({ slug }: { slug: string }) {
  const [page, setPage] = useState<PolicyDto>();
  const [error, setError] = useState<string>();
  const [all, setAll] = useState<{ slug: string; title: string }[]>([]);
  useEffect(() => {
    policies.get(slug).then((p) => { setPage(p); document.title = `${p.title} · Buddy Bay`; }, (e: Error) => setError(e.message));
    policies.list().then((r) => setAll(r.pages), () => {});
  }, [slug]);
  return (
    <div className="policy-page">
      <header className="topbar">
        <a className="brand small" href="/">Buddy Bay</a>
        <span className="spacer" />
        <a className="btn ghost" href="/">Back to the game</a>
      </header>
      <main className="policy-body">
        {error && <p className="form-error">{error}</p>}
        {page && (
          <article className="panel">
            <h1 className="policy-title">{page.title}</h1>
            <p className="muted small-print">Last updated {new Date(page.updatedAt).toLocaleDateString(undefined, { dateStyle: 'long' })}</p>
            <Markdown source={page.body} />
          </article>
        )}
        <PolicyLinks pages={all} />
      </main>
    </div>
  );
}

export function PolicyLinks({ pages }: { pages?: { slug: string; title: string }[] }) {
  const [list, setList] = useState(pages ?? []);
  useEffect(() => {
    if (!pages) policies.list().then((r) => setList(r.pages), () => {});
    else setList(pages);
  }, [pages]);
  if (!list.length) return null;
  return (
    <nav className="policy-links" aria-label="Policies">
      {list.map((p) => <a key={p.slug} href={`/policies/${p.slug}`}>{p.title}</a>)}
    </nav>
  );
}
